import React from 'react';

/* Accordion header icons, one per section. Web equivalents of the SF Symbols
   used in MatchDetailSheet.swift: figure.run, person.badge.plus, graduationcap,
   dollarsign.circle, briefcase, building.columns, shield.lefthalf.filled.
   All decorative — the header text names the section. */

const svg = (paths, { fill = 'none' } = {}) => (
  <svg
    width="18" height="18" viewBox="0 0 24 24" fill={fill}
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
  >
    {paths}
  </svg>
);

export const SportsIcon = () => svg(<>
  <circle cx="14" cy="4" r="2" />
  <path d="M13 8l-3 3 2 4-4 6" />
  <path d="M10 11l-4 1" />
  <path d="M15 15l3 1" />
</>);

export const CoachesIcon = () => svg(<>
  <circle cx="9" cy="8" r="3.5" />
  <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
  <path d="M18 8v6M15 11h6" />
</>);

export const AcademicsIcon = () => svg(<>
  <path d="M12 4L2 9l10 5 10-5-10-5z" />
  <path d="M6 11.5V17c0 1.7 2.7 3 6 3s6-1.3 6-3v-5.5" />
</>);

export const FinanceIcon = () => svg(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M12 7v10M14.5 9.5c0-1.1-1.1-2-2.5-2s-2.5.9-2.5 2 1.1 2 2.5 2 2.5.9 2.5 2-1.1 2-2.5 2-2.5-.9-2.5-2" />
</>);

export const JobsIcon = () => svg(<>
  <rect x="2" y="7" width="20" height="13" rx="2" />
  <path d="M9 7V5a2 2 0 012-2h2a2 2 0 012 2v2" />
  <path d="M2 12h20" />
</>);

export const CampusIcon = () => svg(<>
  <path d="M3 10l9-6 9 6" />
  <path d="M5 10v9M10 10v9M14 10v9M19 10v9" />
  <path d="M2 20h20" />
</>);

export const CrimeIcon = () => svg(<>
  <path d="M12 3l8 3v6c0 4.5-3.2 7.9-8 9-4.8-1.1-8-4.5-8-9V6l8-3z" />
  <path d="M12 3v18" />
</>);
